import { useState } from "react";
import { trustLogos } from "@/mocks/home";

export default function TrustBar() {
  const doubled = [...trustLogos, ...trustLogos];
  return (
    <section className="py-10 md:py-12 border-y border-background-200 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <p className="text-center text-xs uppercase tracking-widest text-foreground-500 mb-7">
          Trusted by carriers, resellers and CPaaS platforms
        </p>
        <div className="relative overflow-hidden">
          <div className="flex vx-marquee items-center gap-14 whitespace-nowrap">
            {doubled.map((logo, i) => {
              const key = `${logo.name}-${i}`;
              if (logo.src) {
                const containerBg = logo.isWhite
                  ? "bg-foreground-800 rounded-lg px-4 py-2"
                  : "";
                return (
                  <LogoTooltip key={key} name={logo.name}>
                    <div
                      className={`flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity select-none ${containerBg}`}
                    >
                      <img
                        src={logo.src}
                        alt={logo.name}
                        className="h-7 w-auto max-w-[160px] object-contain"
                      />
                    </div>
                  </LogoTooltip>
                );
              }
              return (
                <div
                  key={key}
                  className="flex items-baseline gap-1 text-foreground-700 font-heading text-lg opacity-70 hover:opacity-100 transition-opacity select-none"
                >
                  <span className={logo.style}>{logo.text || logo.name}</span>
                  {logo.sub && (
                    <span className="text-foreground-400 text-sm font-medium">{logo.sub}</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

function LogoTooltip({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) {
  const [show, setShow] = useState(false);
  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div className="absolute -top-9 left-1/2 -translate-x-1/2 z-20 pointer-events-none">
          <div className="bg-foreground-900 text-background-50 text-xs font-medium px-3 py-1.5 rounded-md whitespace-nowrap shadow-sm">
            {name}
            <div className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-2 h-2 bg-foreground-900 rotate-45" />
          </div>
        </div>
      )}
    </div>
  );
}